/**
 * Notification GraphQL Fragments
 *
 * Complete fragment for Notification primitive matching GQL output fields
 */

import { gql } from '@apollo/client';

/**
 * Complete Notification fields fragment - all GQL output fields for parity
 */
export const NOTIFICATION_FIELDS_FRAGMENT = gql`
  fragment NotificationFields on Notification {
    # Core Identity (4 fields - tenant_id is graphql(skip))
    id
    workflowInstanceId
    primitiveType
    version

    # Append-Only Fields (3 fields)
    parentId
    originalId
    isActive

    # Notification Definition (8 fields)
    notificationTitle
    messageTemplate
    notificationType
    priority
    channels
    recipientActorIds
    ccActorIds
    bccActorIds

    # Formula Interaction (7 fields)
    triggerEventId
    triggerEntityId
    triggerEntityType
    relatedTaskIds
    relatedSlaIds
    relatedApprovalIds
    relatedTransactionIds

    # Runtime State (7 fields)
    status
    sentAt
    deliveredAt
    readAt
    deliveryAttempts
    lastDeliveryError
    expiresAt

    # Audit Trail (2 fields - createdBy/updatedBy are graphql(skip), use resolvers)
    createdAt
    updatedAt

    # Compliance (3 fields)
    complianceFrameworks
    retentionUntil
    archived

    # Complex Object Resolvers (3 fields)
    compressedId
    createdByActor {
      id
      displayName
      role
    }
    updatedByActor {
      id
      displayName
      role
    }
  }
`;
